import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'cp-icon',
  template: `
    <div [class]="iconClass" [ngClass]="colorClass">
    </div>
  `,
  styles: [`
    :host { display: flex; }
    .icon-16 { font-size: 16px }
    .icon-26 { font-size: 26px }
    .icon-30 { font-size: 30px }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class IconComponent {
  @Input()
  icon: string;

  @Input()
  size = 16;

  @Input()
  colorClass = 'branding-accent-normal-foreground';

  get iconClass() {
    return `cp-icon-${this.icon} icon-${this.size}`;
  }
}

